import React, { useEffect, useState } from 'react';
import { Button, Modal, Space, Spin, Upload, message } from 'antd';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import Constants from '../../../lib/Constants';

const Addfileproducts = ({ingresados, modal, order, producto, bodegaId, onSuccess }) => {
  const [totalerrores, setTotalErrores] = useState(0);
  const [loading, setLoading] = useState(false);
  const [archivocargado, setArchivocargado] = useState(false);
  const [processingComplete, setProcessingComplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [fileList, setFileList] = useState([]);
  const [duplicates, setDuplicates] = useState([]);
  const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);

  const userdata = useSelector(state => state.userdata);

  useEffect(() => {
    if (!modal) {
      setFileList([]);
      resetStates();
    }
  }, [modal]);

  const resetStates = () => {
    setTotalErrores(0);
    setArchivocargado(false);
    setProcessingComplete(false);
    setErrorMessage('');
  };

  const handleFileUpload = async file => {
    if (!file.name.toLowerCase().endsWith('.csv')) {
      message.error('Por favor selecciona un archivo CSV válido');
      return false;
    }

    setLoading(true);
    resetStates();

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('estado', '5');
      formData.append('ordenCompraIngreso', order);
      formData.append('productoId', producto.producto_detalle.id);
      formData.append('productoOdcId', producto.id);
      formData.append('bodegaId', bodegaId);
      formData.append('userId', userdata.id);

      const response = await fetch(
        Constants.URL_COMPLEMENTO + '/api/seriales/upload',
        {
          method: 'POST',
          body: formData,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Error al procesar el archivo');
      }
      console.log(result);

      const { results } = result;

      setTotalErrores(results.duplicados + (results.errores || 0));
      setLoading(false);
      setArchivocargado(true);
      setProcessingComplete(true);
const pendientes = producto.cantidad - ingresados;
      if (
        
        results.total > pendientes
      ) {
        Modal.error({
          title: 'Validación de tamaño de archivo',
          content: `El archivo contiene ${
            results.total
          } registros pero solo se pueden subir ${
           pendientes
          } registros`,
        });
        return false;
      }


      if (results.totalDuplicados > 0) {
        setDuplicates(results.duplicados);
      }

      if (results.totalDuplicados === 0 && results.errores === 0) {
        onSuccess();
        Modal.success({
          title: 'Proceso completado exitosamente-',
          content: (
            <div>
              <p>Se crearon {results.insertados} seriales correctamente</p>
              <p>Total procesados: {results.total}</p>
            </div>
          ),
        });
      } else {
        onSuccess();
        Modal.warning({
          title: 'Proceso completado con advertencias',
          content: (
            <div>
              <p style={{ color: 'green' }}>
                ✅ Se crearon correctamente: {results.insertados} seriales
              </p>
              {results.totalDuplicados > 0 && (
                <div>
                  <p style={{ color: 'orange' }}>
                    ⚠️ Seriales duplicados: {results.totalDuplicados}
                  </p>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr 1fr',
                      fontSize: '0.5em',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      border: '1px solid #d9d9d9',
                      padding: '8px',
                      borderRadius: '4px',
                    }}
                  >
                    {results.duplicados.map((serial, index) => (
                      <div key={index}>
                        {typeof serial === 'object'
                          ? serial.serial
                          : String(serial)}
                      </div>
                    ))}
                  </div>
                  <Button
                    type="primary"
                    style={{ marginTop: '10px' }}
                    onClick={() => {
                      const content = results.duplicados
                        .map(
                          dup =>
                            `Serial: ${dup.serial}, ICCID: ${dup.iccid}, MIN: ${dup.min}, Caja: ${dup.caja}`
                        )
                        .join('\n');
                      const blob = new Blob([content], { type: 'text/plain' });
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = 'seriales_duplicados.txt';
                      document.body.appendChild(a);
                      a.click();
                      window.URL.revokeObjectURL(url);
                      document.body.removeChild(a);
                    }}
                  >
                    Descargar duplicados en TXT
                  </Button>
                </div>
              )}
              {results.errores > 0 && (
                <p style={{ color: 'red' }}>❌ Errores: {results.errores}</p>
              )}

              {results.detalleErrores?.length > 0 && (
                <div
                  style={{
                    maxHeight: '200px',
                    overflow: 'auto',
                    marginTop: '10px',
                  }}
                >
                  <p>
                    <strong>Detalles de errores:</strong>
                  </p>
                  <ul>
                    {results.detalleErrores.map((error, index) => (
                      <li key={index}>
                        Fila {error.fila}: {error.serial} - {error.error}
                      </li>
                    ))}
                  </ul>
                  {results.masErrores && (
                    <p style={{ fontStyle: 'italic' }}>
                      ... y {results.masErrores} errores más
                    </p>
                  )}
                </div>
              )}
            </div>
          ),
        });
      }

      setFileList([]);
    } catch (error) {
      console.error('Error al procesar archivo:', error);
      setLoading(false);
      setErrorMessage(error.message);

      Modal.error({
        title: 'Error al procesar archivo',
        content: (
          <div>
            <p>{error.message}</p>
            <p>Por favor verifica:</p>
            <ul>
              <li>
                Que el archivo tenga las columnas: serial, iccid, min, caja,
                grupo
              </li>
              <li>Que el formato sea CSV válido</li>
              <li>Que los datos estén completos</li>
            </ul>
          </div>
        ),
      });
    }

    return false;
  };

  const handleDownloadDuplicates = () => {
    if (duplicates.length === 0) return;

    const content = duplicates
      .map(
        dup =>
          `Serial: ${dup.serial}, ICCID: ${dup.iccid}, MIN: ${dup.min}, Caja: ${dup.caja}`
      )
      .join('\n');

    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'duplicados.txt';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  useEffect(() => {
    resetStates();
    setFileList([]);
  }, [producto]);

  const uploadProps = {
    accept: '.csv',
    beforeUpload: handleFileUpload,
    fileList,
    onChange: ({ fileList }) => setFileList(fileList),
    showUploadList: {
      showPreviewIcon: false,
      showRemoveIcon: true,
    },
    onRemove: () => {
      setFileList([]);
      resetStates();
    },
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space direction="vertical">
        <div>
          <strong>Instrucciones:</strong>
          <p>
            Selecciona un archivo CSV con las columnas:{' '}
            <code>serial,iccid,min,caja,grupo</code>
          </p>
          <p>Los datos deben estar separados por comas (,)</p>
        </div>

        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />} disabled={loading}>
            Seleccionar archivo CSV
          </Button>
        </Upload>

        <Button
          onClick={() => {
            setFileList([]);
            resetStates();
          }}
          disabled={loading}
        >
          Reset
        </Button>
      </Space>

      <Spin
        spinning={loading}
        tip="Procesando archivo, por favor espere..."
        size="large"
      >
        <div className="content" style={{ minHeight: '50px' }} />
      </Spin>

      {processingComplete && (
        <div style={{ marginTop: '16px' }}>
          <p style={{ color: 'green', fontWeight: 'bold' }}>
            ✅ Se terminó de procesar el archivo
          </p>

          {totalerrores > 0 && (
            <div
              style={{
                padding: '12px',
                backgroundColor: '#fff7e6',
                border: '1px solid #ffd591',
                borderRadius: '6px',
                marginTop: '8px',
              }}
            >
              <p style={{ color: '#d46b08', margin: 0 }}>
                ⚠️ Se encontraron {totalerrores} registros con problemas
                (duplicados o errores)
              </p>
            </div>
          )}

          {errorMessage && (
            <div
              style={{
                padding: '12px',
                backgroundColor: '#fff2f0',
                border: '1px solid #ffccc7',
                borderRadius: '6px',
                marginTop: '8px',
              }}
            >
              <p style={{ color: 'red', margin: 0 }}>❌ {errorMessage}</p>
            </div>
          )}
        </div>
      )}

      <Modal
        title="Seriales Duplicados"
        open={showDuplicatesModal}
        onCancel={() => setShowDuplicatesModal(false)}
        width={800}
        footer={[
          <Button
            key="download"
            type="primary"
            onClick={handleDownloadDuplicates}
          >
            <DownloadOutlined /> Descargar duplicados
          </Button>,
          <Button key="close" onClick={() => setShowDuplicatesModal(false)}>
            Cerrar
          </Button>,
        ]}
      >
        <div style={{ maxHeight: '400px', overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0' }}>
                <th style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                  Serial
                </th>
                <th style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                  ICCID
                </th>
                <th style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                  MIN
                </th>
                <th style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                  Caja
                </th>
              </tr>
            </thead>
            <tbody>
              {duplicates.map((dup, index) => (
                <tr key={index}>
                  <td style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                    {dup.serial}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                    {dup.iccid}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                    {dup.min}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #d9d9d9' }}>
                    {dup.caja}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </Space>
  );
};

export default Addfileproducts;
